import { useQuery } from "@tanstack/react-query";

import { buildHref } from "@softmax/web-addresses";

import { useActualViewer } from "@softmax/web-features/session/records";

import { useGameContext } from "@/features/game/state";

import { OnePager } from "./onepager/one-pager";

import { playShellOptions } from "./play.queries";
import { PlayResource } from "./play-resource";

export function PlayPage() {
  const game = useGameContext();
  const path = buildHref({
    name: "game.play",
    game: game.address,
    league: game.league?.requestedSlug ?? undefined,
  });
  const viewer = useActualViewer();
  const query = useQuery({
    ...playShellOptions(game.publicPath),
    enabled: game.league?.public === true || Boolean(viewer.data),
  });
  return (
    <PlayResource query={query} requiresSession={game.league?.public !== true}>
      {(shell) => <OnePager shell={shell} path={path} />}
    </PlayResource>
  );
}
